<template>
  <div class="bg-white">
    <loading :status="loading" />
    <template v-if="order.id">
      <div class="space-x-2 flex justify-between">
        <!-- <qr-code v-if="order.qr_link" :size="Number(app.printer.qr_code_size)" :color="app.printer.font_color" :text="`${order.qr_link}`"></qr-code> -->
         <h2 class="w-full font-bold tracking-wider uppercase">
          <span class="text-xl">{{ app.name }}</span>
          <small>
            <p v-if="app.phone">{{ app.phone }}</p>
            <p v-html="app.address"></p>
          </small>
        </h2>
      </div>
      <div class="border-b border-dotted border-black w-full p-1"></div>

      <div class="flex items-center mt-1">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Buy product invoice date') }}</label>
        <span class="mr-4 inline-block">:</span>
        <div>{{ order.created_at }}</div>
      </div>
      <div class="flex items-center">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Buy product Invoice ID') }}</label>
        <span class="mr-4 inline-block">:</span>
        #{{ order.tracking }} [ {{ order.id }} ]
      </div>

      <div class="w-full bg-gray-100 mb-1 mt-1 overflow-hidden">
        <div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Customer name') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ order.name | capitalize }}</div>
          </div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Customer phone') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ order.phone | capitalize }}</div>
          </div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Customer email') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ order.email | capitalize }}</div>
          </div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Customer address') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ order.address | capitalize }}</div>
          </div>
        </div>
      </div>
      <div class="w-full bg-gray-100 mb-1 mt-1 overflow-hidden">
        <div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Device model') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ order.model }}</div>
          </div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('IMEI') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ order.imei }}</div>
          </div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Serial number') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ order.serial_number }}</div>
          </div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Quantity') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ order.qty }}</div>
          </div>
          <div class="flex items-center">
            <label class="min-w-32 block font-bold uppercase">{{ $t('Attachments') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div class="md:flex bg-yellow-200 p-3 rounded-md md:space-x-2">
              <div class="w-full md:w-1/2">
                <img :src="order.image" class="w-48 h-48 md:h-auto w-auto" />
              </div>
              <div class="w-full md:w-1/2">
                <img :src="order.docs" class="w-48 h-48 md:h-auto w-auto" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full bg-gray-100 mb-1 mt-1 overflow-hidden">
        <div class="flex justify-between font-semibold">
          <p>{{ $t('Price') }} :</p>
          <p class="pl-2">{{ order.price | currency }}</p>
        </div>
      </div>
      <div class="border-b border-dotted border-black w-full"></div>

      <div class="pt-2">
        <template v-if="app.terms.custom_products">
          <div class="font-bold text-left">
            {{ $t('I acknowledge the following terms and conditions') }}
          </div>
          <div class="terms px-5">
            <p v-html="app.terms.custom_products"></p>
          </div>
        </template>
        <div class="flex justify-between">
          <div class="font-bold flex-1">
            {{ $t('Signature') }}
          </div>
          <div class="font-sm">------------------------------</div>
        </div>
      </div>
      <div class="flex place-content-center">
        <barcode width="1" :lineColor="app.printer.font_color" :value="order.tracking" class="self-center" height="25" />
      </div>
    </template>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
import VueQRCodeComponent from 'vue-qrcode-component';

export default {
  name: 'custom-bill',
  metaInfo() {
    return {
      title: this.$i18n.t('Print bill order'),
    };
  },
  components: {
    'qr-code': VueQRCodeComponent,
    barcode: VueBarcode,
  },
  computed: {
    app() {
      return this.$store.getters['app/getSettings'];
    },
  },
  data() {
    return {
      loading: false,
      order: {
        qr_link: null,
        tax: {
          rate: 0,
          tax_id: null,
          is_tax_included: false,
          is_tax_fix: false,
        },
      },
    };
  },
  mounted() {
    this.getCustomProductOrder();
  },
  methods: {
    getCustomProductOrder() {
      this.loading = true;
      axios
        .get(route('print-custom-product-order', this.$route.params.uuid))
        .then((response) => {
          this.order = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
